import { render } from "./affTicket.vue?vue&type=template&id=46d47d6b"
import script from "./affTicket.vue?vue&type=script&lang=ts"
export * from "./affTicket.vue?vue&type=script&lang=ts"
script.render = render

export default script